var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    strokeLinecap: "round",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8a3 3 0 1 1 3 3v3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17.5a.5.5 0 0 1-.5.5h0a.5.5 0 0 1-.5-.5h0a.5.5 0 0 1 .5-.5h0a.5.5 0 0 1 .5.5h0z",
    fill: "#5B6B7D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/FAQ.b2968b2baae970b15ea5f6ff1fc5694d.svg";
export { ForwardRef as ReactComponent };